import { on } from '@ember/modifier';
import { action } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismIcon } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import GeneralCalendarsMonthsCalendarMonth from 'lumen/components/general/calendars/months/calendar-month';

interface GeneralCalendarsCalendarDaySignature {
  Args: {
    isDisabled: unknown;
    maxDate: unknown;
    minDate: unknown;
    selectDay: unknown;
    selected: unknown;
  };
}

export default class GeneralCalendarsCalendarDay extends Component<GeneralCalendarsCalendarDaySignature> {
  // The focus month in the calendar
  @tracked month = dayjs();

  numberOfMonthsShown = 3;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasNextMonths() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.maxDate.isAfter(
      this.month.add(this.numberOfMonthsShown - 1, 'month'),
      'month',
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasPreviousMonths() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.minDate.isBefore(this.month, 'month');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get months() {
    const months = [];
    for (let i = 0; i < this.numberOfMonthsShown; i++) {
      months.push(this.month.add(i, 'month'));
    }
    return months;
  }

  @action
  nextClicked(): void {
    if (this.hasNextMonths) {
      this.month = dayjs(this.month, 'MM-YYYY').add(3, 'month');
    }
  }

  @action
  onInsert(): void {
    // @ts-expect-error: Incorrect type
    this.month = this.args.selected;
  }

  @action
  previousClicked(): void {
    if (this.hasPreviousMonths) {
      this.month = dayjs(this.month, 'MM-YYYY').subtract(3, 'month');
    }
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div class="flex justify-center" {{didInsert this.onInsert}}>
      <div class="arrow-wrapper">
        <div
          class="switchmonth switch-to-previous-month
            {{unless this.hasPreviousMonths 'disabled'}}"
          role="button"
          {{on "click" this.previousClicked}}
        >
          <PrismIcon @name="chevron-left" />
        </div>
      </div>
      <div class="months-container">
        {{#each this.months as |month|}}
          <GeneralCalendarsMonthsCalendarMonth
            {{! @glint-expect-error: Incorrect type }}
            @isDisabled={{@isDisabled}}
            @maxDate={{@maxDate}}
            @minDate={{@minDate}}
            @month={{month}}
            @selectDay={{@selectDay}}
            @selected={{@selected}}
          />
        {{/each}}
      </div>
      <div class="arrow-wrapper">
        <div
          class="switchmonth switch-to-next-month
            {{unless this.hasNextMonths 'disabled'}}"
          role="button"
          {{on "click" this.nextClicked}}
        >
          <PrismIcon @name="chevron-right" />
        </div>
      </div>
    </div>
  </template>
}
